import {Component, OnInit, ViewChild, ElementRef, ChangeDetectorRef} from '@angular/core';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatDialog} from '@angular/material/dialog';
import { PreviousImportsPopupComponent } from '../previous-imports-popup/previous-imports-popup.component';
import { FireworkTypeMappingService } from "../../../services/firework-type-mapping.service";
import { FireworkType } from "../../../interfaces/firework-type.interface";
import {Brand} from "../../../interfaces/brand.interface";
import {PerformANewImportComponent} from "./perform-a-new-import/perform-a-new-import.component";
import {FireworkTypesMappingsComponent} from "./firework-types-mappings/firework-types-mappings.component";
import {ProductNumberReplacementComponent} from "./product-number-replacement/product-number-replacement.component";
import { AutomatedImportComponent } from './automated-import/automated-import.component';
import { FireworksService } from 'src/app/services/fireworks.service';
import { CsvService } from 'src/app/services/csv.service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'app-fireworks-imports',
    templateUrl: './fireworks-imports.component.html',
    styleUrls: ['./fireworks-imports.component.scss'],
    standalone: false
})
export class FireworksImportsComponent implements OnInit {
	brand: Brand | undefined;
	fireworkTypes!: FireworkType[];
	downloadingCSV = false;

	@ViewChild(MatPaginator) 	paginator!: MatPaginator;
	@ViewChild(MatSort) sort!: MatSort;
	@ViewChild('search') search!: ElementRef;
	@ViewChild('csvReader') csvReader!: ElementRef;
	@ViewChild('performANewImportComponent') performANewImportComponent!: PerformANewImportComponent;
	@ViewChild('productNumberReplacementComponent') productNumberReplacementComponent!: ProductNumberReplacementComponent;
	@ViewChild('fireworkTypesMappingsComponent') fireworkTypesMappingsComponent!: FireworkTypesMappingsComponent;
	@ViewChild('automatedImport') automatedImport!: AutomatedImportComponent;
  constructor(public dialog: MatDialog, private fireworkTypeMappingService: FireworkTypeMappingService,
		private ref: ChangeDetectorRef,
		private fireworksService: FireworksService,
		private csvService: CsvService,
	private _snackBar: MatSnackBar) {

	}

	ngAfterViewInit() {
		this.ref.detectChanges();
	}

  openPreviousPopup() {

    const dialogRef = this.dialog.open(PreviousImportsPopupComponent, {
      	id: 'import-popup',
		maxWidth: '767px',
		width: '100%',
		data: {
			brand: this.brand,
		}
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(`Dialog result: ${result}`);
    });
  }
  ngOnInit(): void {
  }
  init(brand: Brand, fireworkTypes: FireworkType[]): void{
		this.brand = brand;
		this.fireworksService.setBrandId(this.brand.id);
		this.fireworkTypes = fireworkTypes;
		this.performANewImportComponent.init(this.brand, this.fireworkTypes);
		this.productNumberReplacementComponent.init(this.brand);
		this.fireworkTypesMappingsComponent.init(this.brand, this.fireworkTypes);
		this.automatedImport.init(this.brand);
	}
  downloadCSV(){
	if(!this.downloadingCSV){
		this.downloadingCSV = true;
		this._snackBar.open('Downloading the CSV file...', 'Dismiss');
		this.fireworksService.index({}, 'name', 'asc',
					1, -1).subscribe(response => {
			let data = response.data.map((row:any) => {
				return {
					name: row.name,
					firework_type: row.firework_type ? row.firework_type.name : '',
					part_number: row.part_number,
					description: row.description,
					duration: row.duration,
					video_url: row.videos.length > 0 && row.videos[0].url ? row.videos[0].url : row.video_url,
					image_url: row.images.length > 0 && row.images[0].url ? row.images[0].url : row.image_url,
					website_url: row.website_url,
					qrcode: row.qrcode,
					barcode1: row.barcode1,
					barcode2: row.barcode2,
					pro_use: row.is_pro_use ? 'Yes' : 'No'
				}
			});
			this.csvService.exportToCsv('fireworks.csv', data, [
				'Name',
				'Firework Type',
				'Part Number',
				'Description',
				'Duration',
				'Video URL',
				'Image URL',
				'Website URL',
				'QR Code',
				'Barcode 1',
				'Barcode 2',
				'Pro Use'
			]);
			this._snackBar.dismiss();
			this.downloadingCSV = false;
		});
	}
  }
}
